export default __webpack_public_path__ + "static/media/user_avatar.2a9e74e7.svg";